export default __webpack_public_path__ + "static/media/Elena Z 1.fee2c764.png";